import { TourStep } from "./components/GuidedTour";
import { store } from "../../redux/store";
import { updateAddNodes, updateAddLinks } from "../../redux/features/nodes/nodes.slice";

export const housingEditorTourSteps: TourStep[] = [
    {
        targetSelector: ".svgDualGraph",
        title: "The Housing Canvas",
        description:
            "This is your housing canvas. In housing mode, rooms are added from the sidebar — not by clicking the canvas directly. Use the Add Room button on the left to get started.",
        placement: "bottom",
        onExit: () => {
            const nodes = store.getState().nodesState.nodes;
            if (nodes.length === 0) {
                const cx = Math.round((window.innerWidth / 2) / 20) * 20;
                const cy = Math.round((window.innerHeight / 2.5) / 20) * 20;
                store.dispatch(
                    updateAddNodes({
                        id: 0,
                        x: cx - 160,
                        y: cy,
                        label: "Living Room 1",
                        color: "#1C4C82",
                        roomtype: "Living Room",
                        width: { max: 20, min: 12 },
                        height: { max: 16, min: 10 },
                        ratio: { max: 2, min: 1 },
                    }),
                );
                store.dispatch(
                    updateAddNodes({
                        id: 1,
                        x: cx + 160,
                        y: cy,
                        label: "Bedroom 1",
                        color: "#1C4C82",
                        roomtype: "Bedroom",
                        width: { max: 16, min: 10 },
                        height: { max: 14, min: 10 },
                        ratio: { max: 2, min: 1 },
                    }),
                );
                store.dispatch(
                    updateAddLinks({ source: 0, target: 1, color: "black" }),
                );
            }
        },
    },
    {
    targetSelector: "[data-tour='bhk-presets']",
    title: "BHK Preset Graphs",
    description:
        "These are predefined room graphs for 1BHK, 2BHK, and 3BHK layouts. Click any preset to instantly load all rooms and their connections onto the canvas — saving you time setting up from scratch.",
    placement: "top",
},
    {
        targetSelector: "[data-tour='left-sidebar']",
        title: "Room Dimensions Sidebar",
        description:
            "This panel shows all your rooms. Each room displays its name, width, and height. You can edit dimensions directly here or delete rooms using the red icon.",
        placement: "right",
    },
    {
        targetSelector: ".container",
        title: "Add Room",
        description:
            "Click the Add Room button to open a dialog where you can select room types like Bedroom, Kitchen, Living Room, Bathroom and more. You can select multiple rooms at once and add them all together.",
        placement: "right",
    },
    {
        targetSelector: ".vertex",
        title: "Room Nodes",
        description:
            "Each circle represents a room with its label. Hover over a node to see its editor. Drag from one node to another to create an adjacency relationship between rooms.",
        placement: "auto",
    },
    {
        targetSelector: ".edge-group",
        title: "Adjacency Between Rooms",
        description:
            "Lines connecting nodes represent room adjacency. Hover over an edge to change it to Adjacency, Non-Adjacency, or delete it. These relationships guide the floorplan generation.",
        placement: "auto",
    },
    {
        targetSelector: "[data-tour='right-sidebar']",
        title: "Floorplan Options",
        description:
            "Configure dimensioned or dimensionless floorplan generation here. Switch between plan types and set plot size constraints before generating.",
        placement: "left",
    },
    {
        targetSelector: "[data-tour='generate-floorplans']",
        title: "Generate Floorplans",
        description:
            "Once you've added your rooms and set up adjacencies, click here to generate housing floorplan layouts based on your room graph.",
        placement: "top",
    },
    {
        targetSelector: "[data-tour='edit-floorplan']",
        title: "Edit Floorplan",
        description:
            "Select a generated floorplan and click here to open the Output Editor where you can customize walls, doors, windows, and room images.",
        placement: "top",
    },
];